import React from "react";
import { Box, Text, Heading, IconSvgButton } from "samba-ui";

import { getClientView, setClientView } from "../utils/clientView";

const isClientView = getClientView();

const NoAssignedDashboard = () => {
  return (
    <Box textAlign="center" mt={132}>
      {!isClientView ? (
        <Box>
          <Text fontSize={5} fontWeight={700} letterSpacing={1}>
            No dashboards are assigned to your account
          </Text>
          <Heading fontSize={4} fontWeight={600}>
            Please contact your Samba TV representative
          </Heading>
          <Box mb={3}>
            <Text>Try refreshing the page to see changes.</Text>
          </Box>
        </Box>
      ) : (
        <Box>
          <Text fontSize={5} fontWeight={700} letterSpacing={1}>
            No dashboards are assigned to your account
          </Text>
          <Box mb={3}>
            <Text>
              You can reach out Samba TV admins to assign dashboards for your
              account
            </Text>
          </Box>
        </Box>
      )}

      <Box mt={4}>
        <IconSvgButton
          name={isClientView ? "house" : "reload"}
          onClick={() =>
            isClientView ? setClientView("off") : window.location.reload()
          }
        >
          {isClientView ? "Switch to Admin View" : "Refresh"}
        </IconSvgButton>
      </Box>
    </Box>
  );
};

export default NoAssignedDashboard;
